export const BASE_ROUTE = '/catalog';

export const allowedEntitiesPerPage = [12, 24, 48];

export const KINDS_NOT_ALLOWED_IN_ALL_TAB = ['Location'];

export const KINDS_NOT_ALLOWED_IN_OWNED_TAB = [
  'User',
  'Repository',
  'Group',
  'Domain',
  'Location',
];
